// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"65f48bd3","793":"1863a048"}[chunkId] + ".chunk.js";
};